import { lazy, Suspense } from "react";
import SessionsLayout from "./SessionsLayout";

const Signup = lazy(() => import("./Signup"));
const Signin = lazy(() => import("./Signin"));
const Error404 = lazy(() => import("./Error"));
const ForgotPassword = lazy(() => import("./ForgotPassword"));
const TwoFactorVerify = lazy(() => import("./TwoFactorVerify"));

const sessionsRoutes = [
  {
    path: "/sessions",
    element: <SessionsLayout />,
    children: [
      {
        path: "signup",
        element: (
          <Suspense>
            <Signup />
          </Suspense>
        ),
      },
      {
        path: "signin",
        element: (
          <Suspense>
            <Signin />
          </Suspense>
        ),
      },
      {
        path: "verify-2fa",
        element: (
          <Suspense>
            <TwoFactorVerify />
          </Suspense>
        ),
      },
      {
        path: "forgot-password",
        element: (
          <Suspense>
            <ForgotPassword />
          </Suspense>
        ),
      },
      {
        path: "404",
        element: (
          <Suspense>
            <Error404 />
          </Suspense>
        ),
      },
    ],
  },
];

export default sessionsRoutes;
